import { render, staticRenderFns } from "./RestrictSPInCellTooltip.vue?vue&type=template&id=2a9eb8ac&"
import script from "./RestrictSPInCellTooltip.vue?vue&type=script&lang=ts&"
export * from "./RestrictSPInCellTooltip.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports